import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-03b6de71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Ejercicios", -1))
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = { class: "modern-table" }
const _hoisted_5 = { class: "question" }
const _hoisted_6 = ["href"]

import {ref,onMounted, Ref} from 'vue'
  import DefaultLayout from '@/layouts/DefaultLayout.vue';
  import ExercisesService from '@/services/ExerciseService';
  import ProdevValidator from '@/components/auth/ProdevValidator.vue';
  import { useRoute } from 'vue-router';
  import main from '@/data/main.js';
  //import main from '@/data/main.js';

   
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityQuestionsView',
  setup(__props) {

  const route = useRoute()
  const loading = ref(false)
  const service = new ExercisesService()
  const pdf = ref('')
  const questions:Ref<any> = ref({})

  onMounted(async()=>{
    loading.value = true;
      questions.value = await service.GetExercisesDetail(route.params.id)
      pdf.value = await service.GetPdf(route.params.id)
      loading.value = false;
  })

  
  
return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createVNode(ProdevValidator),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_unref(main).TH_1_ACTIVITY_VIEW), 1),
                _createElementVNode("th", null, _toDisplayString(_unref(main).TH_2_ACTIVITY_VIEW), 1),
                _createElementVNode("th", null, _toDisplayString(_unref(main).TH_3_ACTIVITY_VIEW), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (elm) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: elm.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(elm.order), 1),
                  _createElementVNode("td", _hoisted_5, _toDisplayString(elm.title), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      href: `/respuesta/${elm.id}`,
                      target: "_blank"
                    }, [
                      _createVNode(_component_v_icon, {
                        name: "md-fileopen-round",
                        class: "ver",
                        fill: {'color': _unref(main).THIRD_COLOR},
                        scale: "2"
                      }, null, 8, ["fill"])
                    ], 8, _hoisted_6)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})